import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const integrateInventory = unaryRpc({
  name: "integrateInventory" as const,
  input: z.void(),
  output: z.object({ response: z.string() }),
});
